import { gql } from '@apollo/client';

export const UPDATE_SCADA_UPLOAD = gql`
  mutation UpdateScadaUpload($updates: [UpdateScadaUploadInput!]!, $reason: String) {
    updateScadaUpload(updates: $updates, reason: $reason) {
      success
      message
      results {
        SCADA_upload_id
        success
        error
      }
    }
  }
`;